import React, { useState, useEffect } from 'react'
import Accordition from '../../components/common/Accordition'
import { apiConfig } from '../../api/ApiConfig'

const Progress = () => {
  const { fetchSimilarityLogs } = apiConfig()
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [similarityLogs, setSimilarityLogs] = useState([])
  const [targetPredLogs, setTargetPredLogs] = useState([])
  const [protienPredLogs, setProtienPredLogs] = useState([])
  const [molecularDockLogs, setMolecularDockLogs] = useState([])
  const [reqId, setReqId] = useState(localStorage.getItem('request_id') || '')

  useEffect(() => {
    const fetchLogs = async () => {
      if (!reqId) {
        setLoading(false)
        return
      }
      try {
        const data = await fetchSimilarityLogs(reqId)
        setSimilarityLogs(data)
        console.log(similarityLogs)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchLogs()
  }, [reqId])

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedReqId = localStorage.getItem('request_id')
      setReqId(updatedReqId)
    }

    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  return (
    <div>
      <h1>Progress Logs</h1>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error.message}</p>}
      <Accordition
        setSimilarityLogs={setSimilarityLogs}
        similarityLogs={similarityLogs}
        targetPredLogs={targetPredLogs}
        protienPredLogs={protienPredLogs}
        molecularDockLogs={molecularDockLogs}
      />
    </div>
  )
}

export default Progress
